import ssoImg1 from "./../../../../assets/images/708.png"; // Adjust the path as necessary
import ssoImg2 from "./../../../../assets/images/283.png"; // Adjust the path as necessary

function AuditAccreditationAuthorizedTab() {
  return (
    <>
      <div className="service-title font-700 mb-3 text-uppercase">
        Audit and Accreditation
        <span className="text-orange-ef3e33 font-400"> Authorised </span>
      </div>

      <div className="row g-3 g-sm-4 g-md-5">
        <div className="col-lg">
          <p className="text-primary-color mb-3">
            The Office is responsible for maintaining SAMSA's standards by means
            of audits and accreditation of Maritime Training, Education
            Programmes, Institutions and Marine Safety equipment's.
          </p>

          <p className="text-primary-color mb-3 font-600">
            Our key areas are :
          </p>

          <ul class="green-star-ul">
            <li>Audits and Accreditation - SAMSA manages an audit program to  ensure SAMSA standards of examination, certification, assessment and accreditation are maintained.</li>
            <li>Medical Practitioner - Medical Practitioners must be accredited by SAMSA to conduct a medical examination for Seafarers. Only medical  fitness certificates provided by Accredited Medical Practitioners are  accepted.</li>
            <li>Training Institutions - Training Institution accreditation  including curriculum and lecturer accreditation ensure adherence to the  quality standards set by SAMSA and international conventions and  agreements.</li>
            <li>Shipping Company's Accelerated Training programmes  accredited where possible to allow Seafarers a reduced qualifying  service. Audits (scheduled and ad hoc) ensure that the required quality  and standards are maintained.</li>
            <li>Service Stations and Lifesaving Equipment - In order to provide  vessel and seafarer equipment, Services stations, equipment and  maintenance stations must be approved.</li>
            <li>Authorised Agencies - SAMSA uses Authorised Agencies to assist in surveys of small vessels. These Authorsed Agencies must be accredited  and are audited on a regular basis.</li>
            <li>STCW I/10 Recognition - The STCW I/10 Recognition agreements are  based on various conventions and Memoranda of Understanding. The process is a legal process.</li>
          </ul>

          <p className="text-primary-color mb-3">
            In order sustain these the Office manages an audit program to ensure
            SAMSA standards are maintained. The Office promotes inter-
            Administration discussions on mutual acceptance of qualifications
            and standards and recognition of Certificates of Competency.
          </p>

          <p className="text-primary-color mb-3">
            For guidance on SAMSA's Audit and Accreditation requirements please
            contact a{" "}
            <a className="text-orange-ef3e33" href="#">
              SAMSA office
            </a>
            .
          </p>
        </div>
        {/* <div className="col-lg-5">
          <div className="row g-3 g-sm-3 g-md-4 g-lg-4">
            <div className="col-lg-12 col-md-6 col-sm-6">
              <img src={ssoImg1} className="img-fluid rounded-1" alt="" />
            </div>
            <div className="col-lg-12 col-md-6 col-sm-6">
              <img src={ssoImg2} className="img-fluid rounded-1" alt="" />
            </div>
          </div>
        </div> */}
       
      </div>
    </>
  );
}

export default AuditAccreditationAuthorizedTab;
